import { requests } from "../../../api/agent"

export default {
	create                : (params) => requests.post('/ReSpentTimeUnit/create', params),
	update                : (params) => requests.post('/ReSpentTimeUnit/update', params),
	delete                : (params) => requests.getWithParams('/ReSpentTimeUnit/delete', params),
	restore               : (params) => requests.getWithParams('/ReSpentTimeUnit/restore', params),
	getPaged              : (params) => requests.getWithParams('/ReSpentTimeUnit/getPaged', params),
	getPagedAll           : (params) => requests.getWithParams('/ReSpentTimeUnit/getPagedAll', params),
	getPagedAudit         : (params) => requests.getWithParams('/ReSpentTimeUnit/getPagedAudit', params),
	getList               : (params) => requests.getWithParams('/ReSpentTimeUnit/getList', params),
}